<template>
  <div class="p-5">

    <el-button style="float: right" type="text" @click="toggle_masonary_layout = !toggle_masonary_layout">
      {{ toggle_masonary_layout ? 'Switch to masonary layout' : 'Switch to full layout' }}
      <!-- TODO: Buttons aus Tagesplanner hier einbauen -->
    </el-button>

    <h3 class="m-0 mb-1">Ideas</h3>
    <div style="color: #999" class="mb-6">This is a place to store your ideas for future projects or goals.</div>

    <hr />

    <!-- {{templateLog(1)}} -->
    <div v-if="ideas_sorted.$readySome"
      :class="{
        'idea-page__masonary' : true,
        'idea-page__masonary--full': toggle_masonary_layout ||  edit_mode_active
      }">
      <!-- {{templateLog(2)}} -->
      <div
        class="idea-page__masonary-item postit"
        v-for="idea in ideas_sorted_not_deleted"
        :key="idea.$key"
        :style="cssCustomDesign( idea.design )">
        <div style="float: right;">

          <ellipsis-button
            style="display: inline-block;"
            heading="Idea actions"
            :show-options="['slot', 'archive', 'delete']"
            @archive="onDeleteIdea( idea.$id, true )"
            @delete="onDeleteIdea( idea.$id, false )">
            <el-button-group style="margin: 1em 0; display: block">
              <el-button size="small" style="width: 50%; border-radius: 50px 0 0 50px" icon="el-icon-arrow-up" circle @click="onReorder( idea.$id, -1 )"></el-button>
              <el-button size="small" style="width: 50%; border-radius: 0 50px 50px 0" icon="el-icon-arrow-down" circle @click="onReorder( idea.$id, +1 )"></el-button>
            </el-button-group>

            <el-button
              title="Rename"
              class="btn-block ml-0"
              size="mini"
              @click.prevent="onConvertToGoal( idea.$id )">
              <font-awesome-icon icon="bullseye" class="taskicon" />
              Convert to goal
            </el-button>

            <el-button
              title="Rename"
              class="btn-block ml-0"
              size="mini"
              @click.prevent="onConvertToTask( idea.$id )">
              <font-awesome-icon icon="check-circle" class="taskicon" />
              Convert to task
            </el-button>

            <color-selector
              class="mt-2 mb-1"
              headline="Set task label"
              size="small"
              :selected_color="idea.design"
              @color-select="onSelectColor(idea.$id, $event)" />

          </ellipsis-button>
        </div>

        <h3 class="m-0">
          <inline-editable-text
            @change="onSetIdeaName( idea.$id, $event )"
            :value="idea.title"
            :inline="true"
            :reset-on-update="false"
            :reset-on-cancel="false"
            :lost-focus-is-update="false"
            />
        </h3>

        <hr class="mt-3 mb-3">

        <markdown-text
          @input="onSetDescription( idea.$id, $event )"
          @mode-changed="edit_mode_active = $event"
          :value="idea.description"
          :enable-inline-editing="true"  />

        <!-- <pre class="mini-pre w-50">ID: {{idea.$id}}, sortidx: {{idea.sortidx}}</pre> -->
      </div>
    </div>

    <!-- <div class="idea-page__masonary-item postit p-6"> </div> -->
    <el-button @click="onCreateIdea(4)" class="btn-block my-6">
      Create new idea
    </el-button>

    <h3 class="mt-4">Archived ideas</h3>

    <el-button type="text" @click="show_archived = !show_archived">
      {{ show_archived ? 'Hide achieved ideas' : 'Show achieved ideas' }}
    </el-button>

    <div v-if="ideas_sorted.$readySome && show_archived" class="idea-page__masonary">
      <div
        class="idea-page__masonary-item postit postit--deleted"
        v-for="idea in ideas_sorted_deleted"
        :key="idea.$key">
        <strong><del>{{idea.title}}</del></strong>
        <p>{{idea.description}}</p>

        <el-button @click="onRestoreIdea( idea.$id )">
          <font-awesome-icon icon="trash-restore-alt" class="taskicon" />
          Restore
        </el-button>
        <el-button @click="onDeleteIdea( idea.$id, false )" type="danger">
          <font-awesome-icon icon="trash-alt" class="taskicon" />
          Delete
        </el-button>
      </div>
    </div>

    <!-- <el-card class="m-4">
      <pre class="mini-pre">{{one_idea}}</pre>
    </el-card> -->

    <!--
    <el-card class="m-4">
      <el-alert v-if="user_input_error" type="error">Error user input: {{user_input_invalid_list}}</el-alert>

      <el-form label-width="120px">
        <el-form-item label="New idea">
          <el-input v-model="idea_title" class="w-50 mr-4"></el-input>
        </el-form-item>
        <el-form-item label="Description">
          <el-input v-model="idea_description" type="textarea" class="w-50 mr-4"></el-input>
        </el-form-item>
      </el-form>

      <el-button @click="onCreateIdea(2)" type="primary">Create idea</el-button>
      <el-button @click="onCreateIdea(3)" type="secondary">Create idea via modal</el-button>
    </el-card>
    -->

    <el-dialog title="Add new item" :visible.sync="form_visible">
      <el-form
        :rules="rules"
        :model="form"
        ref="ideaForm"
        label-width="120px"
        status-icon>
        <el-form-item label="New idea" prop="title">
          <el-input v-model="form.title" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="Description" prop="description">
          <el-input type="textarea" v-model="form.description" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmitForm">Submit</el-button>
          <el-button @click="onResetForm">Reset</el-button>
        </el-form-item>
      </el-form>
      <pre>form: {{form}}</pre>
    </el-dialog>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ConfirmDeletePromptMixin from "@/components/Mixins/Prompts/ConfirmDeletePrompt"
import GoalAndCommitmentPromptMixin from '@/components/Mixins/Prompts/GoalAndCommitmentPrompt'
import Color from 'color';

// TODO: Don't toggle edit_mode_active, when there are still other editors opened

export default {
  name: "IdeasPage",
  mixins: [ ConfirmDeletePromptMixin, GoalAndCommitmentPromptMixin ],
  data: () => ({
    // Inline:
    idea_title: '',
    idea_description: '',
    search: '',
    user_input_error: false,
    user_input_invalid_list: [],
    show_archived: false,
    toggle_masonary_layout: false,
    edit_mode_active: false,
    // Modal:
    form_visible: false,
    form: {}
  }),
  created() {
    // Start loading on create: this.$models.idea.subscribeList();
  },
  computed: {
    ...mapGetters("user", [
      "userAuth"
    ]),

    ideas_sorted() {
      console.log("[TEMPLATE] ideas_sorted", this.$models.idea.subscribeList());
      // return this.$models.idea.subscribeList();
      return this.$models.idea.subscribeList()
      // or: return this.$db.subscribeList( this.$models.idea )
    },

    ideas_sorted_not_deleted() {
      return this.ideas_sorted.itemsAsArrayWithoutDeleted();
    },

    ideas_sorted_deleted() {
      return this.ideas_sorted.itemsAsArrayOnlyDeleted();
    },

    one_idea() {
      console.log("[TEMPLATE] one_idea");
      return this.$models.idea.subscribeNode('JS4W4oxARVOMmUYoMY_24A');
    },

    ideas_sorted_interactive: {
      get() {
        return this.ideas_sorted;
      },
      set () {
        console.log('ideas_sorted() setter')
      }
    },

    rules() {
      return this.$models.idea.rules;
    }
  },
  methods: {
    templateLog(...args) {
      console.log("[TEMPLATE]", ...args);
      return ''
    },

    cssCustomDesign( design ) {
      if ( !design || design === 'default' ) {
        return {}
      }
      let color = Color( design ).lighten(0.3).desaturate(0.2)
      return {
        background: `linear-gradient(
           135deg,
           ${color} 0%,
           ${color.saturate(0.5).lighten(0.1)} 82%,
           ${color.saturate(0.5).lighten(0.1)} 82%,
           ${color.lighten(0.25)} 100%)`,
        color: color.isDark() ? 'white' : 'inherit'
      }
    },

    onCreateIdea(variant) {
      let sortidx = 1

      let items = this.ideas_sorted.itemsAsArray();
      // console.log('this.ideas_sorted length', items.length)
      if (items && items.length > 0) {
        sortidx = items[ items.length - 1 ].sortidx + 1
      }

      switch (variant) {
        case 1:
          // Variante 1:
          let data = {
            title:       this.idea_title,
            description: this.idea_description,
            sortidx:     sortidx
          }
          this.$models.idea.add( data )                     // = new + write
          // or: this.$models.idea.add_from_template(data); // = new_from_template + write
        break

        case 2:
          // Variante 2:
          let model = this.$db.new( this.$models.idea)
          // or: let model = this.$models.idea.new()
          // or: let model = this.$db.new_from_template( this.$models.idea, {} )

          model.title = this.idea_title;
          model.description = this.idea_description;
          model.sortidx = sortidx;

          if ( !model.$isValid() ) {
            this.user_input_error = true;
            this.user_input_invalid_list = Object.keys(model.$invalid);
          } else {
            model.write();
            this.user_input_error = false;
            this.idea_title = '';
            this.idea_description = '';
          }
        break

        case 3:
          this.form = this.$db.new_from_template( this.$models.idea )
          this.form.sortidx = sortidx;
          this.form_visible = true;
          this.form.setValidationBehaviour('ELEMENT_VALIDATION')
        break

        case 4:
          this.$models.idea.add({ title: 'New idea', sortidx } )
        break
      }
    },

    onDeleteIdea( ideaId, soft_delete = true ) {
      // TODO: Update sortidx
      if ( soft_delete ) {
        return this.$models.idea.remove( ideaId, true );
      }
      this.$confirm_delete_prompt('idea').then(({ notify }) => {
        this.$models.idea.remove( ideaId, soft_delete ).then(notify)
        // or: this.$db.remove( this.model, ideaId )
      }).catch(e => e)
    },

    onRestoreIdea( ideaId ) {
      this.$models.idea.restore( ideaId )
    },

    onSubmitForm() {
      console.log("onSubmitForm");
      this.$refs.ideaForm.validate((valid) => {
        if (valid) {
          this.form.write().then(() => {
            this.form_visible = false;
          });
        } else {
          return false;
        }
      });
    },

    onResetForm() {
      this.$refs.ideaForm.resetFields();
    },

    onSetIdeaName( idea_id, title ) {
      console.log("onSetIdeaName", idea_id, title);
      this.$models.idea.update( idea_id, { title: title })
    },

    onSetDescription(idea_id, description) {
      console.log("onSetDescription", idea_id, description )
      this.$models.idea.update( idea_id, { description: description })
    },

    updateItem( idea_id ) {

      // Variante 1:
      let idea = this.$models.idea.getNode( idea_id );
      idea.title = 'ABC';
      idea.write()

      // Variante 2:
      this.$models.idea.update( idea_id, { title: 'adsasd' })

      // this.idea_list.update( idea_id, { title: this.idea_title, description: this.idea_description })
    },

    onReorder( idea_id, direction ) {
      console.log("onReorder", idea_id, direction);
      /*
      let items = this.ideas_sorted.itemsAsArray();
      let sortidx = items.find(item => item.$id === idea_id).sortidx + direction
      this.$models.update( idea_id, { sortix: sortidx })
      */
      let list = this.ideas_sorted.itemsAsArray().map(item => item.$id);
      let idx = list.findIndex( item => item === idea_id );
      if ( !( idx === 0 && direction === -1 ) ) {
        list.move( idx, idx + direction ) // not native
        this.$models.idea.reorder( list )
      }
    },

    onSelectColor( idea_id, color ) {
      this.$models.idea.update( idea_id, { design: color })
    },

    onConvertToGoal( idea_id ) {
      let idea = this.ideas_sorted.items[ idea_id ]
      this.$api.goal_create({
        name:       idea.title,
        picture:    '',
        isTeamgoal: false,
        dataMeta: {
          description: idea.description,
        }
      }).then(() => {
        return this.onDeleteIdea( idea_id, true ) // Archive this idea
      }).then(() => {
        this.$message({
          message: 'Goal successfully created',
          type: 'success'
        });
      })
    },

    onConvertToTask( idea_id ) {
      let idea = this.ideas_sorted.items[ idea_id ]

      this.$goal_commitment_prompt()
      .then(({ targetGoalId, targetCommitmentId, targetMemberId, done }) => {

        let data = {
          name: idea.title,
          description: idea.description,
          // Set sortidx, otherwise we can not obtain a sortidx,
          // since task list is not loaded in all cases
          sortidx: 50,
        }

        // TODO: Test if this works with backlogs
        this.$api.task_create_user({
          goal_id:   targetGoalId,
          parent_id: targetCommitmentId,
          member_id: targetMemberId,
          data:      data
        }).then(() => {
          return this.onDeleteIdea( idea_id, true ) // Archive this idea
        }).then(() => {
          done();
          this.$message({
            message: 'Task successfully created',
            type: 'success'
          });
        })
      })
    },
  },
  components: {
  }
};

// ...mapGetters('ideas', [
//   "idea_list_sorted"
// ]),
// ...mapResourceGetter('MyIdeas', [     // IDEE
//   'get_ideas_sorted'
// ]),
//
//this.idea_list.addIdea(data) // -> creates a new goal at /goal/<newId>/meta
// this.$db.new( this.$models.idea, data )
// console.log(data)

/*
let ideaStore = new GenericStore('/user/{uid}/ideas/*', ideaTypeDefinition)
goal_deadline_list = new GenericStore('/goal/{goalId}/meta/deadlines/*', GoalMetaTypeDefinition)
goal_deadline_list.define({ goalId: 'KrZPg8N6THOisFz_T992Zg' })
goal_deadline_list.add({ title: 'My deadline' })

this.$models.ideas.with({ uid: UserAuth.uid, taskId: asjdalkdsj }).add('')

let my_store = this.$models.ideas.with({ uid: UserAuth.uid, taskId: asjdalkdsj })
my_store.update('asd')
my_store.update('asd')
my_store.update('asd')

this.$models.ideas.add('asd')
this.$models.ideas.remove('asd')
this.$models.ideas.update('asd')
this.$models.ideas.sync_list('asd')
*/
</script>

<style>
.idea-page__masonary {
  column-count: 3;
  widows: 1;
  orphans: 1;
  column-gap: 0.5em;
}
@media (max-width: 1024px) {
  /* TODO: Depends on sessionbar */
  .idea-page__masonary { column-count: 2; }
  @media (max-width: 580px) {
    .idea-page__masonary { column-count: 1; }
  }
}

.idea-page__masonary-item {
  display: inline-block;
  width: 100%;
  margin-bottom: 1em;
}

.idea-page__masonary--full {
  column-count: 1 !important;
}

.postit {
  position: relative;
  padding: 1em;
  border-bottom: 1px solid #ffffff80;
  border-bottom-right-radius: 100px 15px;
  background: linear-gradient(135deg, #ffff88 81%, #ffff88 82%, #ffff88 82%, #ffffc6 100%);
}

.postit::after {
  content: "";
  position: absolute;
  z-index: -1;
  right: 0;
 bottom: 20px;
  width: 200px;
  height: 25px;
  box-shadow: 2px 15px 5px rgba(0, 0, 0, 0.3);
  transform: matrix(-1, -0.05, 0, 1.1, 0, 0);
}

.postit--deleted {
  /* background: linear-gradient(135deg, #f39e75 0%,#ffdd88 82%,#ffdd88 82%,#f7ebd3 100%); */
  background: linear-gradient(135deg, #efe9d0 0%, #f1e3c2 82%, #f1e3c2 82%, #eaeae9 100%)
}

.postit .markdown-text__text {
  background: unset;
  border: unset;
}
</style>
